import {classes, style} from './thankyou-view.st.css';
import ThankYouViewIcon from './thankyou-view-icon.svg';
import React from 'react';
import {ButtonType} from '@wix/devzai-utils-react';
import {
    DoppeActionTypeWidgetInnerButton,
} from '../../../components/doppe-action-type-widget-inner-button/doppe-action-type-widget-inner-button';
import {FlexLayout} from '@wix/devzai-common-client';
import {currencyFormatPrice, Price} from '@wix/devzai-utils-common';

export const ThankYouView = React.memo(function ThankYouView(props: ThankYouView.Props) {
    const {
        onConfirm,
        price,
        name,
    } = props;

    const formattedAmount = currencyFormatPrice({
        price: price.amount,
        code: price.currencyCode,
    });

    return (
        <div className={style(FlexLayout.column.default)}>
            <ThankYouViewIcon className={style(FlexLayout.alignSelf.center)} />
            <div className={style(classes.thankYouViewTitle, FlexLayout.alignSelf.center)}>
                Thanks{name ? ` ${name}` : ''}!
            </div>
            <div className={style(classes.thankYouViewContent)}>
                Your payment of {formattedAmount} is being processed.
                <br />A receipt will be sent to your email.
            </div>
            <DoppeActionTypeWidgetInnerButton
                buttonType={ButtonType.NormalButton}
                onClick={onConfirm}
            >
                Done
            </DoppeActionTypeWidgetInnerButton>
        </div>
    );
});

export namespace ThankYouView {
    export interface Props {
        onConfirm: () => void;
        price: Price;
        name: string;
    }
}
